// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#priority[data-v-7529efba] {
	display: inline-block;
}
.app-content-list-item[data-v-7529efba] {
	opacity: .8;
}
.app-content-list-item[data-v-7529efba]:hover {
	background-color: transparent;
	opacity: 0.8;
}
h2[data-v-7529efba] {
	font-weight: normal;
	font-size: 17px;
	margin-bottom: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SectionTitle.vue"],"names":[],"mappings":";AA0BA;CACA,qBAAA;AACA;AAEA;CACA,WAAA;AACA;AAEA;CACA,6BAAA;CACA,YAAA;AACA;AAEA;CACA,mBAAA;CACA,eAAA;CACA,kBAAA;AACA","sourcesContent":["<!--\n  - SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors\n  - SPDX-License-Identifier: AGPL-3.0-or-later\n-->\n\n<template>\n\t<div id=\"priority\">\n\t\t<div class=\"app-content-list-item\">\n\t\t\t<h2>{{ name }}</h2>\n\t\t</div>\n\t</div>\n</template>\n\n<script>\nexport default {\n\tname: 'SectionTitle',\n\tprops: {\n\t\tname: {\n\t\t\ttype: String,\n\t\t\trequired: true,\n\t\t},\n\t},\n}\n</script>\n\n<style scoped>\n#priority {\n\tdisplay: inline-block;\n}\n\n.app-content-list-item {\n\topacity: .8;\n}\n\n.app-content-list-item:hover {\n\tbackground-color: transparent;\n\topacity: 0.8;\n}\n\nh2 {\n\tfont-weight: normal;\n\tfont-size: 17px;\n\tmargin-bottom: 2px;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
